


















































































































































































import Vue from 'vue'
import VideoPlayer from '@/components/product/VideoPlayer.vue'
import Category from '@/models/Category'
import {
  MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE_MOBILE,
  MOBILE_HEADING_MAX_LENGTH
} from '@/helper/constants'
import { getMobileTheme } from '@/helper'
import CategoryTreeNode, {
  CategoryTreeNodeType
} from '@/models/CategoryTreeNode'
import {
  findNextPostId,
  findPreviousPostId,
  getCurrentPostIndex
} from '@/helper/index'
import CommentList from '@/components/comments/CommentList.vue'
import PostMaterialsCard from '@/components/product/PostMaterialsCard.vue'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
import MobileNewYorkActionButtons from '@/components/posts/MobileNewYorkActionButtons.vue'
import { PostService } from '@/services'

export default Vue.extend({
  components: {
    VideoPlayer,
    MobileNewYorkActionButtons,
    BaseIcon
  },
  props: {
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    activePost: {
      type: Object
    },
    category: {
      type: Object
    },
    videoOptions: {
      type: Object
    },
    playlist: {
      type: Array
    },
    disableActions: {
      type: Object
    },
    postCompletionButtonText: String,
    postMarkedAsCompleted: Boolean,
    lessonButton: Object,
    isAdmin: Boolean,
    categoryTree: Array,
    fetchingPost: Boolean,
    fetchingPostCompletionStatus: Boolean,
    disablePostCompletionButton: Boolean,
    completedPostIds: {
      type: Set,
      default: new Set()
    },
    derivePostDescription: Function,
    findSubstringInstances: Function,
    expandPostDetails: Function,
    gotoPreviousPost: Function,
    goToNextPost: Function
  },
  async mounted() {
    try {
      this.post = await PostService.findById(this.postId)
    } catch (error) {
      console.log("Something went wrong")
    }
    window.scrollTo(0, 0)
  },
  metaInfo() {
    const meta = {}
    meta['link'] = [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css?family=Lato',
        vmid: 'newYorkFonts'
      }
    ]
    return meta
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    categoryId(): string {
      return this.$route.params.category_id
    },
    postId(): string {
      return this.$route.params.post_id
    },
    lessonSettings(): object {
      return this.product.customizations?.lessonSettings
    },
    templateId(): string {
      return this.$route.query.template_id
    },
    postDescription(): string {
      return this.showFullDescription
        ? this.activePost.description
        : this.activePost.description &&
            this.activePost.description.slice(0, this.textLimit)
    },
    isExpandable(): boolean {
      return this.activePost.description &&
        this.activePost.description.length > 5700
        ? true
        : false
    },
    themeSettings(): object {
      return this.product.customizations?.lessonSettings?.themeSettings
    },
    sections(): object {
      return this.product.customizations?.lessonSettings?.sections
    },
    postCompletedIcon(): string {
      if (this.sections?.lessonBody?.button?.color) {
        return this.sections?.lessonBody?.button?.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return this.postMarkedAsCompleted
        ? '#2f855a'
        : this.disablePostCompletionButton || this.isAdmin
        ? '#6b7280'
        : '#ffffff'
    },
    navigationButtonColor(): string {
      if (this.sections?.lessonBody?.navigationButton?.color) {
        return this.sections.lessonBody.navigationButton.color
      } else if (this.themeSettings?.primaryStyle?.color) {
        return this.themeSettings?.primaryStyle.color
      }
      return '#709BE0'
    },
    parentCategoryTitle(): string {
      if (this.category.parentCategory) {
        const parentCategory = this.categoryTree.find(
          (node: CategoryTreeNode) => node.id === this.category.parentCategory
        )
        return parentCategory?.node.title
      }
      return null
    },
    markCompletedBtnCss() {
      if (this.disablePostCompletionButton || this.isAdmin) {
        return 'cursor-not-allowed'
      } else if (this.postMarkedAsCompleted) {
        return 'text-green-700'
      }
      return getMobileTheme().primaryText
    },
    availableCategoryTree(): object {
      return this.categoryTree.filter((node: any) => node.node.available)
    },
    availablePlayList(): Array<CategoryTreeNode> {
      return this.playlist.filter(
        (node: any) =>
          node.type === CategoryTreeNodeType.Post ||
          (node.type === CategoryTreeNodeType.Category && node.node.available)
      )
    },
    previousPostData(): object {
      return findPreviousPostId(
        this.availableCategoryTree,
        this.postId,
        this.category,
        this.availablePlayList
      )
    },
    nextPostData(): object {
      return findNextPostId(
        this.availableCategoryTree,
        this.postId,
        this.category,
        this.availablePlayList
      )
    }
  },
  data() {
    return {
      parentCategory: null as Category,
      expandPost: false,
      readMorePost: null,
      post: {},
      showFullDescription: false,
      textLimit: MAXIMUM_CHARACTER_LENGTH_BEFORE_READMORE_MOBILE,
      mobileHeadingLimit: MOBILE_HEADING_MAX_LENGTH
    }
  },
  methods: {
    togglePostCompletion() {
      this.$emit('togglePostCompletion')
    },
    goToMaterials() {
      this.$router.push({
        name: 'post-materials',
        params: {
          id: this.product.id,
          category_id: this.category.id,
          post_id: this.post.id
        }
      })
    },
    goToComments() {
      this.$router.push({
        name: 'post-comments',
        params: {
          id: this.product.id,
          category_id: this.category.id,
          post_id: this.post.id
        }
      })
    },
    getMobileTheme
  }
})
